import React, { useState } from 'react';
import {Drawer, } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { menuStyles } from '../Styles/MenuStyles';
import clsx from 'clsx';
import { ILayoutElement } from '../../../_types/interfaces/IRoute';
import MenuElement from './MenuElement';

type MenuProps = {
    isOpen: boolean;
    close: () => void;
    elems: Array<ILayoutElement>
};

export default function Menu(props: MenuProps) {
    const classes = menuStyles();
    const {isOpen, close, elems} = props;
    const [searchFilter, setSearchFilter] = useState('');

    return (
        <div>
            <React.Fragment key={'left'}>
                <Drawer 
                    classes={{
                        paper:clsx({
                            [classes.rootMenu]: true,
                            [classes.rootMenuMobile]: window.innerWidth < 954
                        })
                    }} 
                    BackdropProps={{classes:{
                        root: classes.backdrop
                        }
                    }}
                    anchor={'left'} 
                    open={isOpen} 
                    onClose={close}
                >
                    <div style={{backgroundColor:'transparent',height: '100%'}}>
                        <aside className={clsx({
                            [classes.slide]: true,
                            [classes.slideMobile]: window.innerWidth < 954
                        })}>
                            <div style={{height: '100%'}}>
                                <div className={classes.topSlide}>
                                    <div className={classes.close} onClick={close}>
                                        <CloseIcon/>
                                    </div>
                                </div>
                                <div className={classes.slideContent}>
                                    <div className={classes.contentGroups}>
                                        <div className={classes.groups}>
                                            {}
                                            <div className={classes.groupContent}>
                                                {
                                                    elems.map((element, ind) =>
                                                        <MenuElement
                                                            key={ind}
                                                            link={element.link}
                                                            icon={element.icon}
                                                            text={element.text}
                                                            newTab={element.newTab}
                                                            onClick={close}
                                                        />
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
                </Drawer>
            </React.Fragment>
        </div>
    );
}
